import React, { useState , useContext } from "react";
import app from "../base";
import { withRouter } from "react-router-dom";
import { AuthContext } from "../Auth";
import NavLogo from "../Asset/NavLogo.png"
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Logo from "../images/logo text.png" 
 import Logo2 from "../images/logo pic.png" 
 import Risk from "../images/risk.png"
import Search from "../images/search.png"
import Start from "../images/start.png"

const Telemedicinedemo1 = ({history}) => {
  const { currentUser } = useContext(AuthContext);
  const [file, setFile] = useState(null);
  const [base64, setBase64] = useState(null);

  
  const handleChange = (e) => {
    const file = e.target.files[0];
    const validImageTypes = ["image/jpeg", "image/png", "image/jpg"];
    if (!validImageTypes.includes(file.type)) {
      console.log("Invalid file type. Please select an image file.");
      return;
    }
    setFile(file);
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = () => {
        const base64 = fileReader.result;
        setBase64(base64);
        console.log(base64)
    };
};

const handleUpload = async () => {
  if (!file) {
      console.log("No file selected. Please select a file before uploading.");
      return;
  }
  const db = app.firestore();
  const fileRef = db.collection("EIPCA").doc();
  try {
      await fileRef.set({ 
        userid: currentUser.uid,
        file: base64,
        status: "NotPredict",
        Result: "null",
        Time: "null",
        History: "NotHistoried"
      });
      alert("File uploaded successfully!");
      history.push("/history");
      window.location.reload(true)
  } catch (error) {
      console.log(error);
  }
};

  const Backhome = () => {
    history.push("/");
    window.location.reload(true)
  }

  const Signout = () => {
    app.auth().signOut();
    history.push("/");
    window.location.reload(true)
  };


// Change file to Field for firestore

  return (
    <>
    <Navbar className="navbar fixed-top navbar-light" expand="lg">
      <Container className="container">
      <Navbar.Brand className="navbar-brand logo-image" href="/">
        <img src= {Logo} />
      </Navbar.Brand>
      <Navbar.Toggle
        className="navbar-toggler p-0 border-0 ml-auto mr-3"
        type="button"
        data-toggle="offcanvas"
        aria-controls="basic-navbar-nav"
      />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="navbar-nav ml-auto">
        <center>
          <li className="nav-item">
          <Nav.Link className="nav-link" href="/">
              บริการ <span className="sr-only">(current)</span>
            </Nav.Link>
          </li>
        </center> 
        <center>
          <li className="nav-item">
          <Nav.Link className="nav-link" href="/">
              ข่าวสารจาก EIPCA <span className="sr-only">(current)</span>
            </Nav.Link>
          </li>
        </center> 
        <center>
          <li className="nav-item">
          <Nav.Link className="nav-link" href="/about">
              เกี่ยวกับเรา
            </Nav.Link>
          </li>
        </center>
        <center>
            <li className="nav-item">
            <Nav.Link class="nav-link" style={{color: "red"}} href="#" onClick={Signout} >ออกจากระบบ</Nav.Link>
            </li>
        </center>
        <center>
          <li className="nav-item">
            <a className= "mx-3" href="/HardwareHistory">
              <img style={{width: "40px", height: "40px"}} src= "https://cdn-icons-png.flaticon.com/512/6522/6522516.png"  />
          </a>
          </li>
        </center>
        <center>
        <li className="nav-item">
          <Nav.Link className="nav-link" href="/SuggestionHealthy">
              TH |
            </Nav.Link>
          </li>
        </center>

        <center>
        <li className="nav-item">
          <Nav.Link className="nav-link" href="/en/SuggestionHealthy">
              EN
            </Nav.Link>
          </li>
        </center>
        
         
        </Nav>
      </Navbar.Collapse>
    </Container>
  </Navbar>
 

    <center>
     {/* Header */}
  <header className="ex-header bg-gray">
    <div className="container">
      <div className="row">
        <div className="col-xl-10 offset-xl-1">
        <h1 >ค้นหาแพทย์โรคหัวใจทั่วไทย</h1>
        <h3>EIPCA จะค้นหาแพทย์ประจำศูนย์โรคหัวใจที่ใกล้คุณที่สุด</h3>
          
          
        </div>{" "}
        {/* end of col */}
      </div>{" "}
      {/* end of row */}
    </div>{" "}
    {/* end of container */}
  </header>{" "}
  </center>
  {/* end of ex-header */}
  {/* end of header */}
  {/* Basic */}
 
  {/* Basic */}

  <center>
  <div id="service" className="filter">
    <div className="basic-3">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            {/* <h1 className="h2-heading">EIPCA</h1>
            <div className="header6" />  */}
            <br />
            <br />
          </div>{" "}
          {/* end of col */}
        </div>{" "}
        {/* end of row */}
        <div className="row">
          <div className="col-lg-12">
            {/* Job */}
            <div className="job-container">
                <h1 className="mb-3 " >ภาคเหนือ</h1>
              <div className="header8" /> <div className="header9" />
              <br />
              <br />
              <div class="dropdown">
                <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenu2" data-bs-toggle="dropdown" aria-expanded="false">
                  เลือกจังหวัดของคุณ
                </button>
                <ul class="dropdown-menu" aria-labelledby="dropdownMenu2">
                  <li><button class="dropdown-item" type="button">เชียงราย</button></li>
                  <li><a href="/Telemedicine" class="dropdown-item" type="button">เชียงใหม่</a></li>
                  <li><button class="dropdown-item" type="button">น่าน</button></li>
                  <li><button class="dropdown-item" type="button">พะเยา</button></li>
                  <li><button class="dropdown-item" type="button">แพร่</button></li>
                  <li><button class="dropdown-item" type="button">แม่ฮ่องสอน</button></li>
                  <li><button class="dropdown-item" type="button">ลำปาง</button></li>
                  <li><button class="dropdown-item" type="button">ลำพูน</button></li>
                  <li><button class="dropdown-item" type="button">ตาก</button></li>
                  <li><button class="dropdown-item" type="button">อุตรดิตถ์</button></li>
                </ul>
              </div>
            </div>{" "}
            <div className="job-container " >
            <h1 className="mb-3" >ภาคกลาง</h1>
              <div className="header8" /> <div className="header9" />
              <br />
              <br />
              <div class="dropdown">
                <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenu2" data-bs-toggle="dropdown" aria-expanded="false">
                  เลือกจังหวัดของคุณ
                </button>
                <ul class="dropdown-menu" aria-labelledby="dropdownMenu2">
                <li><button class="dropdown-item" type="button">กรุงเทพมหานคร</button></li>
                  <li><button class="dropdown-item" type="button">กำแพงเพชร</button></li>
                  <li><button class="dropdown-item" type="button">ฉะเชิงเทรา</button></li>
                  <li><button class="dropdown-item" type="button">ชัยนาท</button></li>
                  <li><button class="dropdown-item" type="button">นครนายก</button></li>
                  <li><button class="dropdown-item" type="button">นครปฐม</button></li>
                  <li><button class="dropdown-item" type="button">นครสวรรค์</button></li>
                  <li><button class="dropdown-item" type="button">นนทบุรี</button></li>
                  <li><button class="dropdown-item" type="button">ปทุมธานี</button></li>
                  <li><button class="dropdown-item" type="button">พระนครศรีอยุธยา</button></li>
                  <li><button class="dropdown-item" type="button">พิจิตร</button></li>
                  <li><button class="dropdown-item" type="button">พิษณุโลก</button></li>
                  <li><button class="dropdown-item" type="button">ลพบุรี</button></li>
                  <li><button class="dropdown-item" type="button">สมุทรปราการ</button></li>
                  <li><button class="dropdown-item" type="button">สมุทรสงคราม</button></li>
                  <li><button class="dropdown-item" type="button">สมุทรสาคร</button></li>
                  <li><button class="dropdown-item" type="button">สิงห์บุรี</button></li>
                  <li><button class="dropdown-item" type="button">สุโขทัย</button></li>
                  <li><button class="dropdown-item" type="button">สุพรรณบุรี</button></li>
                  <li><button class="dropdown-item" type="button">สระบุรี</button></li>
                  <li><button class="dropdown-item" type="button">อ่างทอง</button></li>
                  <li><button class="dropdown-item" type="button">อุทัยธานี</button></li>
                </ul>
              </div>
            </div>{" "}
            <div className="job-container " >
                <h1 className="mb-3" >ภาคตะวันออก</h1>
              <div className="header8" /> <div className="header9" />
              <br/>
              <br />
              <div class="dropdown">
                <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenu2" data-bs-toggle="dropdown" aria-expanded="false">
                  เลือกจังหวัดของคุณ
                </button>
                <ul class="dropdown-menu" aria-labelledby="dropdownMenu2">
                <li><button class="dropdown-item" type="button">จันทบุรี</button></li>
                <li><button class="dropdown-item" type="button">ชลบุรี</button></li>
                <li><button class="dropdown-item" type="button">ตราด</button></li>
                <li><button class="dropdown-item" type="button">ปราจีนบุรี</button></li>
                <li><button class="dropdown-item" type="button">ระยอง</button></li>
                <li><button class="dropdown-item" type="button">สระแก้ว</button></li>
                </ul>
              </div>
            </div>{" "}
            <div className="job-container " >
                <h1 className="mb-3" >ภาคตะวันออกเฉียงเหนือ</h1>
              <div className="header8" /> <div className="header9" />
              <br/>
              <br />
              <div class="dropdown">
                <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenu2" data-bs-toggle="dropdown" aria-expanded="false">
                  เลือกจังหวัดของคุณ
                </button>
                <ul class="dropdown-menu" aria-labelledby="dropdownMenu2">
                  <li><button class="dropdown-item" type="button">กาฬสินธุ์</button></li>
                  <li><button class="dropdown-item" type="button">ขอนแแก่น</button></li>
                  <li><button class="dropdown-item" type="button">ชัยภูมิ</button></li>
                  <li><button class="dropdown-item" type="button">นครพนม</button></li>
                  <li><button class="dropdown-item" type="button">นครราชสีมา</button></li>
                  <li><button class="dropdown-item" type="button">บึงกาฬ</button></li>
                  <li><button class="dropdown-item" type="button">บุรีรัมย์</button></li>
                  <li><button class="dropdown-item" type="button">เพชรบูรณ์</button></li>
                  <li><button class="dropdown-item" type="button">มหาสารคาม</button></li>
                  <li><button class="dropdown-item" type="button">มุกดาหาร</button></li>
                  <li><button class="dropdown-item" type="button">ยโสธร</button></li>
                  <li><button class="dropdown-item" type="button">ร้อยเอ็ด</button></li>
                  <li><button class="dropdown-item" type="button">เลย</button></li>
                  <li><button class="dropdown-item" type="button">สกลนคร</button></li>
                  <li><button class="dropdown-item" type="button">สุรินทร์</button></li>
                  <li><button class="dropdown-item" type="button">ศรีสะเกษ</button></li>
                  <li><button class="dropdown-item" type="button">หนองคาย</button></li>
                  <li><button class="dropdown-item" type="button">หนองบัวลำภู</button></li>
                  <li><button class="dropdown-item" type="button">อุดรธานี</button></li>
                  <li><button class="dropdown-item" type="button">อุบลราชธานี</button></li>
                  <li><button class="dropdown-item" type="button">อำนาจเจริญ</button></li>
                </ul>
              </div>
            </div>{" "}
            <div className="job-container " >
                  <h1 className="mb-3" >ภาคตะวันตก</h1>
                <div className="header8" /> <div className="header9" />
                <br/>
                <br />
                <div class="dropdown">
                  <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenu2" data-bs-toggle="dropdown" aria-expanded="false">
                    เลือกจังหวัดของคุณ
                  </button>
                  <ul class="dropdown-menu" aria-labelledby="dropdownMenu2">
                    <li><button class="dropdown-item" type="button">กาญจนบุรี</button></li>
                    <li><button class="dropdown-item" type="button">ประจวบคีรีขันธ์</button></li>
                    <li><button class="dropdown-item" type="button">เพชรบูรณ์</button></li>
                    <li><button class="dropdown-item" type="button">ราชบุรี</button></li>
                  </ul>
                </div>
            </div>{" "}
            <div className="job-container " >
                  <h1 className="mb-3" >ภาคใต้</h1>
                <div className="header8" /> <div className="header9" />
                <br/>
                <br/>
                <div class="dropdown">
                  <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenu2" data-bs-toggle="dropdown" aria-expanded="false">
                    เลือกจังหวัดของคุณ
                  </button>
                  <ul class="dropdown-menu" aria-labelledby="dropdownMenu2">
                    <li><button class="dropdown-item" type="button">กระบี่</button></li>
                    <li><button class="dropdown-item" type="button">ชุมพร</button></li>
                    <li><button class="dropdown-item" type="button">ตรัง</button></li>
                    <li><button class="dropdown-item" type="button">นครศรีธรรมราช</button></li>
                    <li><button class="dropdown-item" type="button">นราธิวาส</button></li>
                    <li><button class="dropdown-item" type="button">ปัตตานี</button></li>
                    <li><button class="dropdown-item" type="button">พังงา</button></li>
                    <li><button class="dropdown-item" type="button">พัทลุง</button></li>
                    <li><button class="dropdown-item" type="button">ภูเก็ต</button></li>
                    <li><button class="dropdown-item" type="button">ระนอง</button></li>
                    <li><button class="dropdown-item" type="button">สตูล</button></li>
                    <li><button class="dropdown-item" type="button">สงขลา</button></li>
                    <li><button class="dropdown-item" type="button">สุราษฎ์ธานี</button></li>
                    <li><button class="dropdown-item" type="button">ยะลา</button></li>
                  </ul>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </center>
  
  <div className="footer bg-gray">
    <div className="container">
      <div className="row">
        <div className="col-lg-12">
          <div className="footer-col first">
            <h6>เกี่ยวกับ EIPCA</h6>
            <p className="p-small">
              EIPCA ย่อมาจาก Electrocardiogram Interpretation Pattern for
              Symptom Predictions of Arrythmia. หรือ
              โปรแกรมเพื่อช่วยคัดกรองภาวะหัวใจวายเฉียบพลัน
              <br />
              (โรคใหลตาย)
              อันเนื่องมาจากภาวะหัวใจเต้นผิดจังหวะจากกราฟคลื่นไฟฟ้าหัวใจด้วยปัญญาประดิษฐ์
            </p>
          </div>{" "}
          {/* end of footer-col */}
          <div className="footer-col second">
            <h6>ติดต่อเรา</h6>
            <ul className="list-unstyled li-space-lg p-small">
              <p>
                <i className="fa fa-map-marker-alt mr-2" />
                EIPCA Team 
              </p>
              <p>
                <i className="fa fa-phone-alt mr-2" />
                093-2789556 , 081-2895915 , 065-3595514
              </p>
              <p>
                <i className="fa fa-envelope mr-2" />
                EIPCA@gmail.com
              </p>
            </ul>
          </div>{" "}
          {/* end of footer-col */}
          <div className="footer-col third">
            <span className="fa-stack">
              <a href="#your-link">
                <i className="fas fa-circle fa-stack-2x" />
                <i className="fab fa-facebook-f fa-stack-1x" />
              </a>
            </span>
            <span className="fa-stack">
              <a href="#your-link">
                <i className="fas fa-circle fa-stack-2x" />
                <i className="fab fa-twitter fa-stack-1x" />
              </a>
            </span>
            <span className="fa-stack">
              <a href="#your-link">
                <i className="fas fa-circle fa-stack-2x" />
                <i className="fab fa-pinterest-p fa-stack-1x" />
              </a>
            </span>
            <span className="fa-stack">
              <a href="#your-link">
                <i className="fas fa-circle fa-stack-2x" />
                <i className="fab fa-instagram fa-stack-1x" />
              </a>
            </span>
            <p className="p-small">
              We would love to hear from you{" "}
              <a href="">
                <strong>EIPCA@gmail.com</strong>
              </a>
            </p>
          </div>{" "}
          {/* end of footer-col */}
        </div>{" "}
        {/* end of col */}
      </div>{" "}
      {/* end of row */}
    </div>{" "}
    {/* end of container */}
  </div>{" "}
  {/* end of footer */}
  {/* end of footer */}
  {/* Scripts */}
  {/* jQuery for Bootstrap's JavaScript plugins */}
  {/* Bootstrap framework */}
  {/* jQuery Easing for smooth scrolling between anchors */}
  {/* Swiper for image and text sliders */}
  {/* Magnific Popup for lightboxes */}
  {/* Morphtext rotating text in the header */}
  {/* Isotope for filter */}
  {/* Custom scripts */}
      
    </>
  );
};

export default withRouter(Telemedicinedemo1);